<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Catalogo de Residentes</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-72 relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
              @change="setFirstPage"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600"></div>
        <button
          class="btn btn-success shadow-md mr-2 w-60"
          @click="showModalCreate"
        >
          Nuevo Residente
        </button>
        <button
          class="btn btn-info shadow-md mr-2 w-60"
          @click="downloadReport"
        >
          Descargar Residentes
        </button>
        <button
          class="btn btn-info shadow-md mr-2 w-60"
          @click="downloadReportHistory"
        >
          Descargar Historiales Clínicos
        </button>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="residents">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table
            class="table table-report -mt-2"
            aria-describedby="administrators table"
          >
            <thead>
              <tr>
                <th id="idH" class="whitespace-nowrap">ID</th>
                <th id="nombre" class="text-center whitespace-nowrap">
                  Nombre Completo
                </th>
                <th id="residencia" class="text-center whitespace-nowrap">
                  Residencia
                </th>
                <th id="date1" class="text-center whitespace-nowrap">
                  Fecha de Ingreso
                </th>
                <th id="date2" class="text-center whitespace-nowrap">
                  Fecha de Nacimiento
                </th>
                <th id="history" class="text-center whitespace-nowrap">
                  Historial Clinico
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in elements" :key="row.id">
                <td class="w-20 font-medium">{{ row.id }}</td>
                <td class="text-center w-10 font-medium">
                  {{ row.full_name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row?.house?.name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ moment(row.date_entry).format('DD-MM-YYYY') }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ moment(row.birth_date).format('DD-MM-YYYY') }}
                </td>
                <td class="text-center w-20 font-medium">
                  <button
                    class="btn btn-success shadow-md mr-2"
                    @click="setViewModalMedical(row)"
                  >
                    Historial Clínico
                  </button>
                </td>
                <td class="table-report__action w-56">
                  <div class="flex flex-col">
                    <div class="flex justify-center mt-2">
                      <a
                        class="flex items-center mr-3 text-green-600"
                        href="javascript:;"
                        @click="setToEdit(row)"
                      >
                        <CheckSquareIcon class="w-4 h-4 mr-1" />
                        Editar
                      </a>
                      <a
                        href="javascript:;"
                        class="flex items-center text-red-700"
                        @click="setToDelete(row)"
                      >
                        <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                      </a>
                    </div>
                    <div class="flex justify-center mt-2">
                      <a
                        class="flex text-green-600"
                        href="javascript:;"
                        @click="downloadHealthLog(row)"
                      >
                        <CheckSquareIcon class="w-4 h-4 mr-1" />
                        Descargar bitácora de salud
                      </a>
                      <vue3-html2pdf
                        :show-layout="false"
                        :enable-download="true"
                        :manual-pagination="true"
                        :filename="'Bitácora de salud de ' + row.full_name"
                        :pdf-quality="2"
                        pdf-format="letter"
                        pdf-orientation="portrait"
                        pdf-content-width="100%"
                        :ref="'downloadPdf' + row.id"
                        style="display: none"
                        :html-to-pdf-options="{
                          enableLinks: true,
                          filename: 'Bitácora de salud de ' + row.full_name
                        }"
                        v-if="row.enablePdfDownload"
                      >
                        <template v-slot:pdf-content>
                          <HealthLog :resident-information="row" />
                        </template>
                      </vue3-html2pdf>
                    </div>
                    <PresionesChart
                      :height="400"
                      :width="600"
                      :results="resIData(row)"
                      :id="'presiones_' + row.id"
                      v-if="row.showmetrics"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Pagination -->
        <div
          class="
            intro-y
            col-span-12
            flex flex-wrap
            sm:flex-row sm:flex-nowrap
            items-center
            py-10
          "
          v-if="pages > 1"
        >
          <ul class="pagination ml-auto" style="margin-right: revert;">
            <li @click="setFirstPage" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronsLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="changePageNegative" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li
              :key="element"
              v-for="element in [...Array(maxShowButtonPages).keys()].map(
                (dataElement, index) =>
                  activeGroup * maxShowButtonPages -
                  (maxShowButtonPages - index) +
                  1
              )"
            >
              <template v-if="element <= pages">
                <a
                  class="pagination__link"
                  href="javascript:;"
                  @click="page = element"
                  :class="{ 'pagination__link--active': element === page }"
                  >{{ element }}
                </a>
              </template>
            </li>
            <li v-if="page !== pages" @click="changePagePositive">
              <a class="pagination__link" href="javascript:;">
                <ChevronRightIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="setlastPage" v-if="page !== pages">
              <a class="pagination__link" href="javascript:;">
                <ChevronsRightIcon class="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
        <!-- END: Pagination -->
      </template>
    </div>
    <!-- BEGIN: MODALS -->

    <!-- BEGIN: Delete Confirmation Modal -->
    <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div v-if="rowSelected" class="modal-body p-0">
            <div class="p-5 text-center">
              <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
              <div class="text-3xl mt-5">¿Estás seguro?</div>
              <div class="text-gray-600 mt-2">
                ¿Realmente quieres eliminar el registro
                <span style="font-weight: bold">{{
                  rowSelected.full_name
                }}</span
                >?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 mr-1"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-danger w-24"
                @click="deleteAction"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->

    <!-- BEGIN: Modal Add Row -->
    <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Nuevo elemento</h2>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre Completo</label>
                <input
                  v-model="createForm.fullName"
                  type="text"
                  class="form-control"
                  placeholder="Nombre Completo"
                  required
                />
                <template v-if="v$.createForm.fullName.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.fullName.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 200 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 flex flex-col">
                <label class="form-label">Fecha de Ingreso</label>
                <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                  <div class="relative w-full mx-auto outline-none">
                    <div
                      class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                    >
                      <CalendarIcon class="w-4 h-4" />
                    </div>
                    <Litepicker
                      v-model="createForm.dateEntry"
                      readonly
                      :options="{
                        lang: 'es-MX',
                        autoApply: false,
                        startDate: '',
                        endDate: '',
                        format: 'YYYY-MM-DD',
                        singleMode: true,
                        numberOfColumns: 1,
                        numberOfMonths: 1,
                        showWeekNumbers: true,
                        dropdowns: {
                          minYear: 1900,
                          maxYear: null,
                          months: true,
                          years: true
                        }
                      }"
                      class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                    />
                  </div>
                </div>
                <template v-if="v$.createForm.dateEntry.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.dateEntry.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 flex flex-col">
                <label class="form-label">Fecha de nacimiento</label>
                <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                  <div class="relative w-full mx-auto outline-none">
                    <div
                      class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                    >
                      <CalendarIcon class="w-4 h-4" />
                    </div>
                    <Litepicker
                      v-model="createForm.birthDate"
                      readonly
                      :options="{
                        lang: 'es-MX',
                        autoApply: false,
                        startDate: '',
                        endDate: '',
                        format: 'YYYY-MM-DD',
                        singleMode: true,
                        numberOfColumns: 1,
                        numberOfMonths: 1,
                        showWeekNumbers: true,
                        dropdowns: {
                          minYear: 1900,
                          maxYear: null,
                          months: true,
                          years: true
                        }
                      }"
                      class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                    />
                  </div>
                </div>
                <template v-if="v$.createForm.birthDate.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.birthDate.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Residencia</label>
                <select
                  v-model="createForm.houseId"
                  data-placeholder="Selecciona la residencia"
                  class="w-full form-select mt-1"
                  required
                >
                  <option
                    v-for="item in housesFull"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <template v-if="v$.createForm.houseId.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.houseId.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'integer'"
                      >El campo deber ser entero</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Especialista</label>
                <select
                  v-model="createForm.specialistId"
                  data-placeholder="Selecciona el especialista"
                  class="w-full form-select mt-1"
                >
                  <option
                    v-for="item in specialistsFull"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }} {{ item.last_name }}
                  </option>
                </select>
                <template v-if="v$.createForm.specialistId.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.specialistId.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'integer'"
                      >El campo deber ser entero</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.createForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.createForm.$invalid }"
              >
                Crear
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Add Row -->

    <!-- BEGIN: Modal Edit Row -->
    <div ref="editRow" class="modal" tabindex="-1" aria-hidden="true">
      <div v-if="rowSelected" class="modal-dialog">
        <form @submit.prevent="editAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Modificar elemento</h2>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre Completo</label>
                <input
                  v-model="editForm.fullName"
                  type="text"
                  class="form-control"
                  placeholder="Nombre Completo"
                  required
                />
                <template v-if="v$.editForm.fullName.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.fullName.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 200 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 flex flex-col">
                <label class="form-label">Fecha de Ingreso</label>
                <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                  <div class="relative w-full mx-auto outline-none">
                    <div
                      class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                    >
                      <CalendarIcon class="w-4 h-4" />
                    </div>
                    <Litepicker
                      v-model="editForm.dateEntry"
                      readonly
                      :options="{
                        lang: 'es-MX',
                        autoApply: false,
                        startDate: '',
                        endDate: '',
                        format: 'YYYY-MM-DD',
                        singleMode: true,
                        numberOfColumns: 1,
                        numberOfMonths: 1,
                        showWeekNumbers: true,
                        dropdowns: {
                          minYear: 1900,
                          maxYear: null,
                          months: true,
                          years: true
                        }
                      }"
                      class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                    />
                  </div>
                </div>
                <template v-if="v$.editForm.dateEntry.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.dateEntry.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 flex flex-col">
                <label class="form-label">Fecha de nacimiento</label>
                <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                  <div class="relative w-full mx-auto outline-none">
                    <div
                      class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                    >
                      <CalendarIcon class="w-4 h-4" />
                    </div>
                    <Litepicker
                      v-model="editForm.birthDate"
                      readonly
                      :options="{
                        lang: 'es-MX',
                        autoApply: false,
                        startDate: '',
                        endDate: '',
                        format: 'YYYY-MM-DD',
                        singleMode: true,
                        numberOfColumns: 1,
                        numberOfMonths: 1,
                        showWeekNumbers: true,
                        dropdowns: {
                          minYear: 1900,
                          maxYear: null,
                          months: true,
                          years: true
                        }
                      }"
                      class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                    />
                  </div>
                </div>
                <template v-if="v$.editForm.birthDate.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.birthDate.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Residencia</label>
                <select
                  v-model="editForm.houseId"
                  data-placeholder="Selecciona la residencia"
                  class="w-full form-select mt-1"
                  required
                >
                  <option
                    v-for="item in houses"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <template v-if="v$.editForm.houseId.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.houseId.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'integer'"
                      >El campo deber ser entero</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Especialista</label>
                <select
                  v-model="editForm.specialistId"
                  data-placeholder="Selecciona el especialista"
                  class="w-full form-select mt-1"
                >
                  <option :value="''">Sin asignar</option>
                  <option
                    v-for="item in specialists"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }} {{ item.last_name }}
                  </option>
                </select>
                <template v-if="v$.editForm.specialistId.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.specialistId.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'integer'"
                      >El campo deber ser entero</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.editForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.editForm.$invalid }"
              >
                Modificar
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Edit Row -->

    <!-- BEGIN: Modal Edit Row -->
    <div ref="rowMedical" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Historial Clínico</h2>
            <a data-dismiss="modal" href="javascript:;">
              <XIcon class="w-5 h-5 text-gray-500" />
            </a>
          </div>
          <!-- END: Modal Header -->
          <!-- BEGIN: Modal Body -->
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label class="form-label">Alergias</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.allergies"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Antecedentes</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.historical"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Social</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.social"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Funcionalidad</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.funcionality"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Sentidos</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.sense"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Cognición</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.cognition"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Ánimo</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.courage"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Nutrición</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.nutrition"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Labs</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.labs"
              >
              </textarea>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Diagnóstico</label>
              <textarea
                class="resize-none border rounded-md form-control h-24"
                v-model="medicalForm.diagnostic"
              >
              </textarea>
            </div>
          </div>
          <!-- END: Modal Body -->
          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-20 mr-1"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="editMedicalAction"
              class="btn btn-primary w-20"
            >
              Modificar
            </button>
          </div>
          <!-- END: Modal Footer -->
        </div>
      </div>
    </div>
    <!-- END: Modal Edit Row -->

    <!-- END: MODALS -->
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import defaultImage from '../../../utils/defaultImage'
import useVuelidate from '@vuelidate/core'
import { maxLength, required, integer } from '@vuelidate/validators'
import { saveAs } from 'file-saver'
import moment from 'moment-timezone'
import Vue3Html2pdf from 'vue3-html2pdf'
import HealthLog from './HealthLog.vue'
import PresionesChart from '@/components/presiones-chart/Main.vue'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      defaultImage: defaultImage,
      moment: moment,
      residents: undefined,
      residents2: undefined,
      new_full_name: undefined,
      new_date: undefined,
      specialists: undefined,
      houses: undefined,
      isAdmin: undefined,
      residentsFull: undefined,
      specialistsFull: undefined,
      housesFull: undefined,
      rowSelected: undefined,
      residentIDs: [],
      createForm: {
        fullName: '',
        dateEntry: '',
        birthDate: '',
        specialistId: '',
        houseId: ''
      },
      editForm: {
        fullName: '',
        dateEntry: '',
        birthDate: '',
        specialistId: '',
        houseId: ''
      },
      search: '',
      elementsByPage: 5,
      maxShowButtonPages: 3,
      page: 1,
      activeGroup: 1,
      medicalForm: {}
    }
  },
  components: {
    Vue3Html2pdf,
    HealthLog,
    PresionesChart
  },
  validations() {
    return {
      createForm: {
        fullName: { required, $autoDirty: true, maxLength: maxLength(200) },
        dateEntry: { required, $autoDirty: true, maxLength: maxLength(250) },
        birthDate: { required, $autoDirty: true, maxLength: maxLength(250) },
        houseId: { required, $autoDirty: true, integer },
        specialistId: { $autoDirty: true, integer }
      },
      editForm: {
        fullName: { required, $autoDirty: true, maxLength: maxLength(200) },
        dateEntry: { required, $autoDirty: true },
        birthDate: { required, $autoDirty: true },
        houseId: { required, $autoDirty: true, integer },
        specialistId: { $autoDirty: true, integer }
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getInitialData()
    await this.getData()
    this.$store.commit('main/setShowSpinner', false)
    window.scrollTo(0, 0)
  },
  methods: {
    async getInitialData() {
      this.setFirstPage()
      this.isAdmin =
        this.$store.state.auth.user.role.role.toUpperCase() === 'ADMIN'
      try {
        const response = this.isAdmin
          ? await this.axios.get('/residents', {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            })
          : await this.axios.get(
              `/client-by-id/${this.$store.state.auth.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.$store.state.auth.token}`
                }
              }
            )
        if (this.isAdmin) {
          if (Array.isArray(response.data) && response.data.length) {
            this.residents = response.data
            this.houses = await this.getHouses()
            this.specialists = await this.getSpecialists()
          }
        } else {
          if (
            response.data &&
            Array.isArray(response.data.residents) &&
            response.data.residents.length
          ) {
            this.residents = response.data.residents
            this.houses = await this.getHouses()
            this.specialists = await this.getSpecialists()
          }
        }
      } catch (error) {
        if (error.response) {
          console.error(error.response)
          this.$toast.error(error.response.data.message, {
            position: 'top'
          })
        }
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async getData() {
      try {
        const fullData = await Promise.all([
          this.axios.get('/residents', {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }),
          this.axios.get('/houses', {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }),
          this.axios.get('/specialists', {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          })
        ])
        this.residentsFull = fullData[0].data || []
        this.housesFull = fullData[1].data || []
        this.specialistsFull = fullData[2].data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    showModalCreate() {
      this.createForm = {
        fullName: '',
        dateEntry: '',
        birthDate: '',
        specialistId: '',
        houseId: ''
      }
      this.v$.$reset()
      const modal = this.$refs.createRow
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    setViewModalMedical(row) {
      this.medicalForm = row.medical
        ? { ...row.medical }
        : { resident_id: row.id }
      const modal = this.$refs.rowMedical
      cash(modal).modal('show')
    },
    async getHouses() {
      try {
        const response = this.axios.get('/houses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        if (Array.isArray(response.data) && response.data.length) {
          return response.data
        }
      } catch (error) {
        console.log('se mostrará la última información')
      }
    },
    async getSpecialists() {
      try {
        const response = this.axios.get('/specialists', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        if (Array.isArray(response.data) && response.data.length) {
          return response.data
        }
      } catch (error) {
        console.log('se mostrará la última información')
      }
    },
    async editMedicalAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.rowMedical
      cash(modal).modal('hide')
      try {
        if (this.medicalForm.id) {
          await this.axios.put(
            `/update-medical-record/${this.medicalForm.id}`,
            this.medicalForm,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
        } else {
          await this.axios.post('/create-medical-record', this.medicalForm, {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          })
        }
        await this.getInitialData()
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        if (this.isAdmin) {
          console.log('admin')
          await this.axios.post(
            '/create-resident',
            {
              full_name: this.createForm.fullName,
              date_entry: this.createForm.dateEntry,
              birth_date: this.createForm.birthDate,
              house_id: this.createForm.houseId,
              specialist_id: this.createForm.specialistId || null
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
        } else {
          await this.axios.post(
            '/create-resident',
            {
              full_name: this.createForm.fullName,
              date_entry: this.createForm.dateEntry,
              birth_date: this.createForm.birthDate,
              house_id: this.createForm.houseId,
              specialist_id: this.createForm.specialistId || null
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
          console.log('entro 1')
          this.new_full_name = this.createForm.fullName
          this.new_date = this.createForm.dateEntry
          this.residents2 = await this.getResident()
          console.log('entro 2 ' + JSON.stringify(this.residents2))
          console.log('entro 2 ' + JSON.stringify(this.residents2[0].id))
          this.residentIDs.push(this.residents2[0].id)
          console.log('entro 3')
          await this.axios.post(
            '/assign-client-residents',
            {
              user_id: this.$store.state.auth.user.id,
              residents: this.residentIDs
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
        }
        await this.getInitialData()
        const modal = this.$refs.createRow
        cash(modal).modal('hide')
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      cash(modal).modal('show')
    },
    async getResident() {
      try {
        const response = await this.axios.get(
          `/resident-by-name-date/${this.new_full_name}/${this.new_date}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        return response.data
      } catch (error) {
        console.log('get resident failed')
      }
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-resident/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToEdit(row) {
      this.rowSelected = row
      this.editForm = {
        fullName: this.rowSelected.full_name,
        dateEntry: this.rowSelected.date_entry,
        birthDate: this.rowSelected.birth_date,
        specialistId: this.rowSelected.specialist_id || '',
        houseId: this.rowSelected.house_id
      }
      this.v$.$reset()
      const modal = this.$refs.editRow
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    async editAction() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const body = {
          full_name: this.editForm.fullName,
          date_entry: this.editForm.dateEntry,
          birth_date: this.editForm.birthDate,
          house_id: this.editForm.houseId,
          specialist_id: this.editForm.specialistId || null
        }
        await this.axios.put(`/update-resident/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        const modal = this.$refs.editRow
        cash(modal).modal('hide')
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async downloadReport() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/resident-file', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          },
          responseType: 'blob'
        })
        saveAs(
          response.data,
          `Residentes Información ${moment().format('DD-MM-YYYY')}.xlsx`
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async downloadReportHistory() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/medical-record-file', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          },
          responseType: 'blob'
        })
        saveAs(
          response.data,
          `Historiales Clínicos Información ${moment().format(
            'DD-MM-YYYY'
          )}.xlsx`
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    },
    async downloadHealthLog(element) {
      this.$store.commit('main/setShowSpinner', true)
      if (!element.image_base_64) {
        try {
          const responseImageBase64 = await this.axios.get(
            `/resident-image-by-id/${element.id}`,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
          element.image_base_64 = responseImageBase64.data || this.defaultImage
        } catch (error) {
          console.log(error)
        }
      }
      if (!element.metricsData) {
        element.showmetrics = true
        await new Promise(resolve =>
          setTimeout(() => {
            const presionesChart = document.getElementById(
              'presiones_' + element.id
            )
            element.metricsData = {
              presiones: presionesChart.toDataURL()
            }
            element.showmetrics = false
            return resolve(true)
          }, 600)
        )
      }
      element.enablePdfDownload = true
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.$store.commit('main/setShowSpinner', false)
      return this.$refs['downloadPdf' + element.id].generatePdf()
    },
    resIData(row) {
      if (row.informations) {
        const tableheaders = []
        for (let i = row.informations.length - 1; i > 0; i--) {
          const test = row.informations[i].cardiaca
          if (test != null) {
            tableheaders.push(row.informations[i])
          }
          if (tableheaders.length >= 30) {
            break
          }
        }
        return tableheaders.reverse()
      }
      return []
    }
  },
  computed: {
    filteredElements() {
      if (this.residents) {
        let elements = this.residents
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.full_name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row?.house?.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    resID() {
      if (this.filteredElements) {
        const tableheaders = []
        for (let i = 0; i < this.filteredElements.length; i++) {
          const test = this.filteredElements[i].id
          tableheaders.push(test)
        }
        return tableheaders
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  },
  watch: {
    resID: {
      deep: true,
      handler: function(newVal) {
        this.residentIDs = newVal
      }
    }
  }
}
</script>
